<div class="shipment-page-header">
    <a (click)="back()" class="fs-4 clickable"><i class="bi bi-arrow-left"></i></a>
    <h1 class="m-0 p-0">{{ "Create shipment sticker" | translate }}</h1>
</div>

<form (ngSubmit)="submit()" [formGroup]="form" *ngIf="form">
    <section class="shipment-section">
        <div class="row g-3">
            <div class="col-12 col-md-6">
                <div class="shipment-address-block">
                    <div class="shipment-address-block__header">
                        <div class="shipment-address-block__title">
                            <i class="bi bi-geo-alt" aria-hidden="true"></i>
                            <h4 class="m-0">{{ "Customer" | translate }}</h4>
                        </div>
                    </div>
                    <div class="shipment-address-block__body">
                        <app-address-card
                            *ngIf="order?.deliveryAddress"
                            [address]="order.deliveryAddress"
                            [canEdit]="false"
                            [canDelete]="false"
                        ></app-address-card>
                        <div class="shipment-address-block__email" *ngIf="order?.customer?.email">
                            <i class="bi bi-envelope" aria-hidden="true"></i>
                            <span>{{ order.customer.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="shipment-address-block">
                    <div class="shipment-address-block__header">
                        <div class="shipment-address-block__title">
                            <i class="bi bi-arrow-return-left" aria-hidden="true"></i>
                            <h4 class="m-0">{{ "Return information" | translate }}</h4>
                        </div>
                        <button type="button" class="btn btn-sm btn-link-primary p-0" (click)="goToAddresses()">
                            {{ "Manage addresses" | translate }}
                            <i class="bi bi-chevron-right" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div class="shipment-address-block__body">
                        <ng-container *ngIf="returnAddressLoaded">
                            <app-address-card
                                *ngIf="returnAddress; else missingReturn"
                                [address]="returnAddress"
                                [canEdit]="false"
                                [canDelete]="false"
                                [roleBadges]="returnAddressBadges"
                            ></app-address-card>
                            <ng-template #missingReturn>
                                <div class="shipment-address-empty">
                                    <i class="bi bi-exclamation-circle shipment-address-empty__icon" aria-hidden="true"></i>
                                    <p class="mb-2" *ngIf="accountType === 'personal'">
                                        {{ "Set a default address in your profile before creating a shipment." | translate }}
                                    </p>
                                    <p class="mb-2" *ngIf="accountType !== 'personal'">
                                        {{ "Set a return address in your profile before creating a shipment." | translate }}
                                    </p>
                                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="goToAddresses()">
                                        {{ "Manage addresses" | translate }}
                                    </button>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="shipment-section shipment-packages">
        <div class="shipment-section__header">
            <div class="shipment-section__title">
                <i class="bi bi-box-seam" aria-hidden="true"></i>
                <h4 class="m-0">{{ "Packages" | translate }}</h4>
            </div>
            <button type="button" class="btn btn-outline-primary shipment-section__action" (click)="addShipmentForm()">
                <i class="bi bi-plus-lg" aria-hidden="true"></i>
                {{ "Add package" | translate }}
            </button>
        </div>

        <div class="shipment-packages__list" *ngIf="getShipmentForms().length > 0; else noPackages">
            <ng-container *ngFor="let shipmentForm of getShipmentForms(); let i = index">
                <div class="shipment-package" [formGroup]="shipmentForm">
                    <div class="shipment-package__header">
                        <h5 class="m-0 p-0 fw-bolder">{{ "Package" | translate }} {{ i + 1 }}</h5>
                        <button type="button" class="btn btn-link text-danger p-0 border-0" (click)="removeShipmentForm(i)">
                            <span class="bi bi-trash"></span>
                        </button>
                    </div>
                    <div class="row g-3">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>{{ "Deci" | translate }}</label>
                                <app-deci-helper
                                    formControlName="deci"
                                    [isInvalid]="shipmentForm.get('deci').invalid && shipmentForm.get('deci').touched"
                                ></app-deci-helper>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>{{ "Weight (g)" | translate }}</label>
                                <input type="number" class="form-control" formControlName="weight" />
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <ng-template #noPackages>
            <div class="shipment-packages__empty">
                <i class="bi bi-box-seam shipment-packages__empty-icon" aria-hidden="true"></i>
                <p class="mb-0">{{ "Add at least one package to create a shipment sticker." | translate }}</p>
            </div>
        </ng-template>
    </section>

    <div class="shipment-form-actions">
        <button type="submit" class="btn btn-primary" [disabled]="!canSubmit">{{ "Save" | translate }}</button>
    </div>
</form>
